import { AvatarImage, ExpandableParagraph, Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import { container, heading } from 'forms/previsit-questions/questionnaireMessageCssDefs';

interface QuestionnaireMessageProps {
  business: consumer.IBusinessConfig;
  message: string;
}

export const QuestionnaireMessage = ({ business, message }: QuestionnaireMessageProps) => {
  const { name, emailLogoUrl } = business;
  return (
    <div css={container}>
      <Typography variant="body02Strong" css={heading}>
        {emailLogoUrl && <AvatarImage size="small" alt={`${name} logo`} src={emailLogoUrl} />}
        {name}
      </Typography>
      <ExpandableParagraph paragraphText={message} cutoffLength={200} />
    </div>
  );
};
